__turbopack_context__.v({
  "leftPanel": "n_URDq_leftPanel",
  "midPanel": "n_URDq_midPanel",
  "midPanelPhone": "n_URDq_midPanelPhone",
  "rightPanel": "n_URDq_rightPanel",
});
